import React from 'react';
import './BottomCTA.css';

export default function BottomCTA() {
  return (
    <section className="bottom-cta-section">
      <div className="bottom-cta-container">
        <h4>Let’s Build Your Success Story</h4>
        <p>Contact our experts today to discuss how we can support your business journey.</p>
        <a href="/contact" className="cta-button">Get Free Consultation</a>
      </div>
    </section>
  );
}
